<template>
  <div class="login-wrapper">
    <div class="login-card">
      <div class="logo-badge">$</div>
      <h1 class="brand-title">FinanceHub</h1>
      <p class="brand-subtitle">Enterprise Finance Management</p>
      <div class="signin-section">
        <h2 class="signin-title">Sign in</h2>
        <p class="signin-description">Enter your credentials to access your account</p>

        <form @submit.prevent="submit">
          <div class="form-group">
            <label class="form-label">Email</label>
            <div class="input-wrapper">
              <span class="input-icon">✉</span>
              <input
                type="email"
                placeholder="you@company.com"
                v-model="form.email"
                class="form-input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Password</label>
            <div class="input-wrapper">
              <span class="input-icon">🔒</span>
              <input
                type="password"
                placeholder="••••••••"
                v-model="form.password"
                class="form-input"
                required
              />
            </div>
          </div>
          <button type="submit" class="signin-button" :disabled="loading">
  <span v-if="loading">Signing in...</span>
  <span v-else>Sign in</span>
</button>

        </form>
      </div>
      <p class="footer-text">Contact your administrator if you need an account</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState('auth', ['loading'])
  },
  methods: {
  ...mapActions('auth', ['login']),

  async submit() {
    try {
      const user = await this.login(this.form)
      if (user.role === 'User') {
        this.$router.push('/dashboard')
      }
    } catch (e) {
      console.error(e)
    }
  }
}
}
</script>

<style scoped>
.login-wrapper {
  min-height: 98vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

.login-card {
  width: 100%;
  max-width: 580px;
  background: white;
  padding: 50px 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
.logo-badge {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
  font-weight: bold;
  margin: 0 auto 24px;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}
.brand-title {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.brand-subtitle {
  font-size: 16px;
  color: #9ca3af;
  margin-bottom: 32px;
  font-weight: 500;
}
.signin-section {
  margin-bottom: 24px;
}

.signin-title {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.signin-description {
  font-size: 14px;
  color: #9ca3af;
  margin-bottom: 28px;
}
.form-group {
  margin-bottom: 20px;
  text-align: left;
}
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-icon {
  position: absolute;
  left: 14px;
  font-size: 18px;
  color: #d1d5db;
  pointer-events: none;
}
.form-input {
  width: 100%;
  padding: 14px 14px 14px 44px;
  font-size: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background-color: #f9fafb;
  color: #1f2937;
  transition: all 0.3s ease;
  font-family: inherit;
}
.form-input::placeholder {
  color: #b4b4b4;
}
.form-input:focus {
  outline: none;
  background-color: #ffffff;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.signin-button {
  width: 100%;
  padding: 14px 16px;
  margin-top: 8px;
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
  font-family: inherit;
}
.signin-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(37, 99, 235, 0.4);
}
.signin-button:active {
  transform: translateY(0);
}
.footer-text {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 20px;
  font-weight: 500;
}
@media (max-width: 580px) {
  .login-card {
    padding: 30px 20px;
    margin: 20px;
  }

  .brand-title {
    font-size: 28px;
  }

  .signin-title {
    font-size: 20px;
  }

  .logo-badge {
    width: 60px;
    height: 60px;
    font-size: 32px;
  }
}
.signin-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

</style>
